import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const RegistrationServiceConfig = {
  name: "Registration",
  annotations: []
} as ServiceConfig;